import { render, staticRenderFns } from "./pictogram-table-activity.vue?vue&type=template&id=dda928b6&scoped=true"
import script from "./pictogram-table-activity.vue?vue&type=script&lang=js"
export * from "./pictogram-table-activity.vue?vue&type=script&lang=js"
import style0 from "./pictogram-table-activity.vue?vue&type=style&index=0&id=dda928b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda928b6",
  null
  
)

export default component.exports